

// ─── UPLOAD DATA ──────────────────────────────────────────────────────────────

// SheetJS (the "xlsx" package) is part of the app now, not loaded from another website.
// It is imported on first use so it stays out of the main download.
const EXCEL_LOAD_ERROR = "Excel could not load. Check your connection and try again.";
function loadXLSX() {
  return import('xlsx').catch(err => {
    console.error('Could not load the Excel library:', err);
    throw new Error(EXCEL_LOAD_ERROR);
  });
}

export { EXCEL_LOAD_ERROR, loadXLSX };
